<!-- command-bar -->
<div class="cbar">
  <div class="ms-CommandBar">
    <div class="ms-CommandBar-mainArea">
      <div class="ms-CommandButton">
        <button
          (click)="abrirModalCrear()"
          class="ms-CommandButton-button"
          type="button"
        >
          <span class="ms-CommandButton-icon ms-fontColor-themePrimary"
            ><i class="ms-Icon ms-Icon--CalculatorAddition"></i
          ></span>
          <span class="ms-CommandButton-label">Nueva Plantilla</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="pageContent">
  <div class="pageTitle">
    <h2>Administración de Plantillas</h2>
  </div>
  <app-data-table
    tableId="datatablePlantillas"
    [serverSide]="true"
    [serverData]="getDataTablePlantillas"
    [columns]="columnas"
    (loadedGrid)="gridLoaded($event)"
    (custom)="customClick($event)"
    [buttonsOptions]="dtOptButtons"
  ></app-data-table>
</div>

<!-- Crear Plantilla -->
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader create-plantilla" appPreventOutsideClick>
    <div id="dialogCreateEdit" class="ms-Dialog-title">Crear Plantilla</div>
    <form
      [formGroup]="plantillaForm"
      (ngSubmit)="crearPlantilla()"
      name="plantillaForm"
    >
      <div class="ms-Dialog-content input-grid form-group">
        <div>
          <app-text-box
            [frm]="plantillaForm"
            formControlName="nombre"
            type="text"
            [required]="true"
            label="Nombre"
          ></app-text-box>
        </div>
        <div>
          <app-text-area
            [frm]="plantillaForm"
            formControlName="descripcion"
            [required]="false"
            label="Descripción"
            rows="3"
          ></app-text-area>
        </div>
        <div>
          <label class="ms-Label is-required" for="archivo">Archivo de Plantilla</label>
          <input 
            type="file" 
            id="archivo"
            class="form-control"
            (change)="onArchivoSeleccionado($event)"
            accept=".docx,.doc,.pdf,.html,.xlsx,.xls"
          >
          <div class="form-text">
            Formatos soportados: DOCX, DOC, PDF, HTML, XLSX, XLS
          </div>
          <p
            style="color: brown"
            *ngIf="formSubmitted && !archivoSeleccionado"
          >
            El archivo es requerido
          </p>
        </div>
        <app-check-box
          [frm]="plantillaForm"
          formControlName="activo"
          label="Activo"
        ></app-check-box>
      </div>
      <app-form-buttons
        [botonProcesando]="botonProcesando"
        buttonCancelId="btnCancel"
        labelCancel="Cancelar"
        buttonSaveId="btnCreateEdit"
        labelSave="Crear"
        [labelLoading]="textoBotonProcesando"
        [frm]="plantillaForm"
        (cancel)="clearFormPlantilla()"
        [validate]="true"
      >
      </app-form-buttons>
    </form>
  </div>
</div>

<!-- Editar Plantilla -->
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader edit-plantilla" appPreventOutsideClick>
    <div class="ms-Dialog-title">Editar Plantilla</div>
    <form
      [formGroup]="editarForm"
      (ngSubmit)="guardarEdicion()"
      name="editarForm"
    >
      <div class="ms-Dialog-content input-grid form-group">
        <div>
          <app-text-box
            [frm]="editarForm"
            formControlName="nombre"
            type="text"
            [required]="true"
            label="Nombre"
          ></app-text-box>
        </div>
        <div>
          <app-text-area
            [frm]="editarForm"
            formControlName="descripcion"
            [required]="false"
            label="Descripción"
            rows="3"
          ></app-text-area>
        </div>
        <div>
          <label class="ms-Label" for="archivoEdit">Reemplazar Archivo (opcional)</label>
          <input
            type="file"
            id="archivoEdit"
            class="form-control"
            (change)="onArchivoEditSeleccionado($event)"
            accept=".docx,.doc,.pdf,.html,.xlsx,.xls"
          >
          <div class="form-text">
            Deje vacío para conservar el archivo actual. Formatos: DOCX, DOC, PDF, HTML, XLSX, XLS
          </div>
          <p *ngIf="archivoEditSeleccionado" class="form-text" style="color: green;">
            Archivo seleccionado: {{ archivoEditSeleccionado.name }}
          </p>
        </div>
        <app-check-box
          [frm]="editarForm"
          formControlName="activo"
          label="Activo"
        ></app-check-box>
      </div>
      <app-form-buttons
        [botonProcesando]="botonProcesando"
        buttonCancelId="btnCancelEdit"
        labelCancel="Cancelar"
        buttonSaveId="btnSaveEdit"
        labelSave="Guardar"
        [labelLoading]="textoBotonProcesando"
        [frm]="editarForm"
        (cancel)="cancelarEdicion()"
        [validate]="true"
      >
      </app-form-buttons>
    </form>
  </div>
</div>

<!-- Modal Visor de Documentos -->
<app-generic-modal 
  [isVisible]="mostrarVisor"
  [title]="'Visor de Plantilla - ' + documentoActual.nombre"
  [showLoading]="cargandoDocumento"
  loadingMessage="Cargando documento..."
  closeButtonLabel="Cerrar"
  (closeModal)="cerrarVisor()">
  
  <div class="document-viewer-container">
    <div #documentContent class="document-content" style="display:none;">
      <!-- Aquí se insertará dinámicamente el iframe -->
    </div>
    
    <div *ngIf="!cargandoDocumento" class="document-actions">
      <button class="ms-Button ms-Button--primary" (click)="descargarDocumento(documentoActual.id)">
        <i class="ms-Icon ms-Icon--Download"></i> Descargar
      </button>
    </div>
  </div>
  
</app-generic-modal>

<!-- Modal Éxito -->
<div class="docs-DialogExample-lgHeader success">
  <div class="ms-Dialog ms-Dialog--lgHeader modal-success" appPreventOutsideClick>
    <div class="ms-Dialog-title">Plantilla Almacenada Correctamente</div>
    <div class="ms-Dialog-content">
      <p class="ms-Dialog-subText">Se ha almacenado la plantilla.</p>
    </div>
    <div class="ms-Dialog-actions">
      <button
        class="ms-Button ms-Dialog-action ms-Button--primary"
        (click)="cerrarModal()"
      >
        <span class="ms-Button-label">Aceptar</span>
      </button>
    </div>
  </div>
</div>

<app-modal-notify></app-modal-notify>